<template>
  <cForm ref="form" :config="config" :grid="grid" :fields="fields"></cForm>
</template>
<script>
import cForm from '@/base/common/component/form.vue'
export default {
  components: {
    cForm
  },
  props: {
    formData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted() {
    this.$refs['form'].setFormData(this.formData)
  },
  data() {
    return {
      config: {
        formBind: {
          labelPosition: 'top',
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px",
          },
        },
      },
      grid: [
        { is_open: 24 },
        { amount: 12, currency: 12 },
        { email: 24 },
        { invoice_info: 12, remarks: 12 },
      ],
      fields: [
        {
          key: 'is_open',
          component: 'Radio',
          options: [],
          optionsFn: 'YesNoNumber',
          optionsKey: '',
          default: 0,
          bind: {
            border: true
          },
          methods: {
            'on-change'({ formData }) {
              console.log(formData);
              if (formData.is_open == 0) {
                formData.amount = ''
                formData.currency = ''
                formData.invoice_info = ''
                formData.remarks = ''
                formData.email = ''
              }
            }
          }
        },
        {
          name: () => this.$tz('邮箱'),
          key: 'email',
          component: 'Input',
          placeholder: () => this.$tz('邮箱'),
          show: ({ row }) => !!row.is_open,
        },
        {
          name: this.$tz('开票,金额'),
          placeholder: () => this.$tz('开票,金额'),
          key: 'amount',
          component: 'InputNumber',
          default: 0,
          bind: {
            border: true,
            min: 0,
            step: 0.01,
            style: 'width:100%'
          },
          show: ({ row }) => !!row.is_open,
        },
        {
          name: this.$tz('币种'),
          key: 'currency',
          component: 'Select',
          placeholder: () => this.$tz('币种'),
          options: [],
          optionsFn: 'getCurrency',
          optionsKey: '',
          default: '',
          show: ({ row }) => !!row.is_open,
        },
        {
          key: 'invoice_info',
          name: () => this.$tz('开票,信息'),
          placeholder() {
            return this.$tz('开票,信息');
          },
          component: 'Input',
          bind: {
            type: 'textarea',
            autosize: { minRows: 2 },
          },
          show: ({ row }) => !!row.is_open,
        },
        {
          key: 'remarks',
          name: () => this.$tz('开票,备注'),
          placeholder() {
            return this.$tz('开票,备注');
          },
          component: 'Input',
          bind: {
            type: 'textarea',
            autosize: { minRows: 2 },
          },
          show: ({ row }) => !!row.is_open,
        },
      ],
    }
  }
}
</script>